import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { SpotIconSparkles } from "./SpotIconSparkles";
import * as Styled from "./SpotIcon.styled";
export const SpotIcon = forwardRef((props, ref) => {
    const { background, foreground, hasSparkles = true, foregroundPalette = "visualizationOne", size = "large", sparklePalette = "illustrativePurple", ...otherProps } = props;
    return (_jsxs(Styled.Wrapper, { "data-testid": "SpotIcon", ref: ref, ...otherProps, size: size, palette: foregroundPalette, viewBox: "0 0 192 128", children: [background, hasSparkles && _jsx(SpotIconSparkles, { palette: sparklePalette }), foreground] }));
});
SpotIcon.displayName = "SpotIcon";
